module.exports = __webpack_public_path__ + "static/img/xinhuawenxuan.d988947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/xinhuawenxuan.jpg
// module id = ddV/
// module chunks = 46